import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const BodyHeader = styled.div`
  padding: 15px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;
const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: ${theme.modernTokens.borderRadius.md};
  padding: 8px 12px;
  border: 1px solid rgba(227, 110, 0, 0.1);
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 18px;
  cursor: pointer;
  color: ${theme.colors.modernPrimary};
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    color: ${theme.colors.modernSecondary};
    transform: scale(1.1);
  }
`;
const SC = {
  Container,
  BodyContainer,
  BodyHeader,
  HeadingTag,
  ValueSpan,
  MoreVertIcon,
  PopoverSpan,
  PopoverContainer,
};

export default SC;
